// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SimulationBankState } from "./simulation-bank-state";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Live state of one scenario bank in a run.
 */
export class SimulationBankStatus implements flatbuffers.IUnpackableObject<SimulationBankStatusT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationBankStatus {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationBankStatus(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationBankStatus,
  ): SimulationBankStatus {
    return (obj || new SimulationBankStatus()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationBankStatus(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationBankStatus,
  ): SimulationBankStatus {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationBankStatus()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  state(): SimulationBankState {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SimulationBankState.WAITING;
  }

  vendorAddress(): string | null;
  vendorAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The simulator's own local listener ("ip:port").
   */
  localAddress(): string | null;
  localAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  localAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  packetsSent(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  packetsReceived(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  loopsCompleted(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  connections(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  lastError(): string | null;
  lastError(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastError(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSimulationBankStatus(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankIdOffset, 0);
  }

  static addState(builder: flatbuffers.Builder, state: SimulationBankState) {
    builder.addFieldInt8(1, state, SimulationBankState.WAITING);
  }

  static addVendorAddress(builder: flatbuffers.Builder, vendorAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, vendorAddressOffset, 0);
  }

  static addLocalAddress(builder: flatbuffers.Builder, localAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, localAddressOffset, 0);
  }

  static addPacketsSent(builder: flatbuffers.Builder, packetsSent: bigint) {
    builder.addFieldInt64(4, packetsSent, 0n);
  }

  static addPacketsReceived(builder: flatbuffers.Builder, packetsReceived: bigint) {
    builder.addFieldInt64(5, packetsReceived, 0n);
  }

  static addLoopsCompleted(builder: flatbuffers.Builder, loopsCompleted: number) {
    builder.addFieldInt32(6, loopsCompleted, 0);
  }

  static addConnections(builder: flatbuffers.Builder, connections: number) {
    builder.addFieldInt32(7, connections, 0);
  }

  static addLastError(builder: flatbuffers.Builder, lastErrorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, lastErrorOffset, 0);
  }

  static endSimulationBankStatus(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimulationBankStatus(
    builder: flatbuffers.Builder,
    bankIdOffset: flatbuffers.Offset,
    state: SimulationBankState,
    vendorAddressOffset: flatbuffers.Offset,
    localAddressOffset: flatbuffers.Offset,
    packetsSent: bigint,
    packetsReceived: bigint,
    loopsCompleted: number,
    connections: number,
    lastErrorOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationBankStatus.startSimulationBankStatus(builder);
    SimulationBankStatus.addBankId(builder, bankIdOffset);
    SimulationBankStatus.addState(builder, state);
    SimulationBankStatus.addVendorAddress(builder, vendorAddressOffset);
    SimulationBankStatus.addLocalAddress(builder, localAddressOffset);
    SimulationBankStatus.addPacketsSent(builder, packetsSent);
    SimulationBankStatus.addPacketsReceived(builder, packetsReceived);
    SimulationBankStatus.addLoopsCompleted(builder, loopsCompleted);
    SimulationBankStatus.addConnections(builder, connections);
    SimulationBankStatus.addLastError(builder, lastErrorOffset);
    return SimulationBankStatus.endSimulationBankStatus(builder);
  }

  unpack(): SimulationBankStatusT {
    return new SimulationBankStatusT(
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.state(),
      this.vendorAddress(),
      this.localAddress(),
      this.packetsSent(),
      this.packetsReceived(),
      this.loopsCompleted(),
      this.connections(),
      this.lastError(),
    );
  }

  unpackTo(_o: SimulationBankStatusT): void {
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.state = this.state();
    _o.vendorAddress = this.vendorAddress();
    _o.localAddress = this.localAddress();
    _o.packetsSent = this.packetsSent();
    _o.packetsReceived = this.packetsReceived();
    _o.loopsCompleted = this.loopsCompleted();
    _o.connections = this.connections();
    _o.lastError = this.lastError();
  }

  unpackFields(...fields: string[]): SimulationBankStatusT {
    const t = new SimulationBankStatusT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("state")) {
      t.state = this.state();
    }
    if (fieldSet.has("vendor_address")) {
      t.vendorAddress = this.vendorAddress();
    }
    if (fieldSet.has("local_address")) {
      t.localAddress = this.localAddress();
    }
    if (fieldSet.has("packets_sent")) {
      t.packetsSent = this.packetsSent();
    }
    if (fieldSet.has("packets_received")) {
      t.packetsReceived = this.packetsReceived();
    }
    if (fieldSet.has("loops_completed")) {
      t.loopsCompleted = this.loopsCompleted();
    }
    if (fieldSet.has("connections")) {
      t.connections = this.connections();
    }
    if (fieldSet.has("last_error")) {
      t.lastError = this.lastError();
    }
    return t;
  }
}

export class SimulationBankStatusT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankId: UuidT | null = null,
    public state: SimulationBankState = SimulationBankState.WAITING,
    public vendorAddress: string | Uint8Array | null = null,
    public localAddress: string | Uint8Array | null = null,
    public packetsSent: bigint = 0n,
    public packetsReceived: bigint = 0n,
    public loopsCompleted: number = 0,
    public connections: number = 0,
    public lastError: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const vendorAddress =
      this.vendorAddress !== null ? builder.createString(this.vendorAddress!) : 0;
    const localAddress = this.localAddress !== null ? builder.createString(this.localAddress!) : 0;
    const lastError = this.lastError !== null ? builder.createString(this.lastError!) : 0;

    return SimulationBankStatus.createSimulationBankStatus(
      builder,
      bankId,
      this.state,
      vendorAddress,
      localAddress,
      this.packetsSent,
      this.packetsReceived,
      this.loopsCompleted,
      this.connections,
      lastError,
    );
  }

  clone(): SimulationBankStatusT {
    const obj = new SimulationBankStatusT();
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.state = this.state;
    obj.vendorAddress = this.vendorAddress;
    obj.localAddress = this.localAddress;
    obj.packetsSent = this.packetsSent;
    obj.packetsReceived = this.packetsReceived;
    obj.loopsCompleted = this.loopsCompleted;
    obj.connections = this.connections;
    obj.lastError = this.lastError;
    return obj;
  }

  equals(other: SimulationBankStatusT): boolean {
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.state !== other.state) return false;
    if (this.vendorAddress !== other.vendorAddress) return false;
    if (this.localAddress !== other.localAddress) return false;
    if (this.packetsSent !== other.packetsSent) return false;
    if (this.packetsReceived !== other.packetsReceived) return false;
    if (this.loopsCompleted !== other.loopsCompleted) return false;
    if (this.connections !== other.connections) return false;
    if (this.lastError !== other.lastError) return false;
    return true;
  }
}

export function verifySimulationBankStatus(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 8);
    verifier.checkScalarField(tablePos, 14, 8);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
